import React from "react";

const sizeMap = {
  xs: "16",
  sm: "20",
  md: "24",
  lg: "32",
};

const colorMap = {
  primary: "text-[var(--primaryColor)]",
  secondary: "text-farmazon-text-muted",
  inherit: "text-inherit",
};

const Spinner = ({ size = 24, color = "primary", className = "", ...rest }) => {
  const resolvedSize = sizeMap[size] || size;

  return (
    <svg
      className={`animate-spin ${colorMap[color] || colorMap.primary} ${className}`}
      width={resolvedSize}
      height={resolvedSize}
      viewBox="0 0 24 24"
      fill="none"
      role="progressbar"
      {...rest}
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="3" opacity="0.25" />
      <path
        d="M22 12a10 10 0 00-10-10"
        stroke="currentColor"
        strokeWidth="3"
        strokeLinecap="round"
      />
    </svg>
  );
};

export default Spinner;
